import PropTypes from 'prop-types'
import React from 'react'

function getClassName (props) {
  const { className } = props
  return ['user__avatar'].concat(className || []).join(' ')
}

function getAvatarStyle (imagePath) {
  const style = {}

  if (imagePath) {
    style.backgroundImage = `url(${imagePath})`
  }

  return style
}

const UserAvatar = React.memo((props) => {
  const { path, name = false } = props
  const initial = name && !path ? name.split('')[0] : false
  return (
    <span
      style={getAvatarStyle(path)}
      className={getClassName(props)}
    >
      {initial && (<span className="user__avatar-initial">{initial}</span>)}
    </span>
  )
})

UserAvatar.displayName = 'UserAvatar'

UserAvatar.propTypes = {
  path: PropTypes.string,
  className: PropTypes.array,
}

export default UserAvatar
